import { addMessages, init, getLocaleFromNavigator } from "svelte-i18n"

import de from "./localization/de.json"
import en from "./localization/en.json"

addMessages("de", de)
addMessages("en", en)

init({
    fallbackLocale: "de",
    initialLocale: getLocaleFromNavigator(),
})
